<template>
    <div class="lg:grid lg:grid-cols-12 lg:gap-x-5">
        <ControlsMenuComponent />

        <div class="space-y-6 sm:px-6 lg:col-span-7 lg:px-0">
            <form @submit.prevent="submit" enctype="multipart/form-data">
                <div class="shadow-sm sm:overflow-hidden sm:rounded-md">
                    <div class="space-y-6 bg-white px-4 py-6 sm:p-6">
                        <div>
                            <h3 class="text-base font-semibold text-gray-900">{{ $t('settings.general') }}</h3>
                            <p class="mt-1 text-sm text-gray-500">{{ $t('settings.general_tip') }}</p>
                        </div>

                        <div class="grid grid-cols-3 gap-6" v-if="user">
                            <AvatarComponent class="col-span-6 sm:col-span-3" :current_url="user.avatar_url" />

                            <div class="col-span-6 sm:col-span-3">
                                <label for="name" class="block text-sm/6 font-medium text-gray-900">{{ $t('settings.name') }}</label>
                                <div class="mt-2 grid grid-cols-1">
                                    <input
                                        id="name"
                                        name="name"
                                        v-model="form.name"
                                        type="text"
                                        autocomplete="name"
                                        :class="{
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': hasError('name')
                                        }" />
                                    <ExclamationCircleIcon v-if="hasError('name')" class="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4" aria-hidden="true" />
                                </div>
                                <p class="mt-2 text-sm text-red-600" id="name-error" v-if="hasError('name')">{{ getError('name') }}</p>
                            </div>

                            <div class="col-span-6 sm:col-span-3">
                                <label for="username" class="block text-sm/6 font-medium text-gray-900">{{ $t('settings.address') }}</label>
                                <div class="mt-2 grid grid-cols-1">
                                    <input
                                        type="text"
                                        name="username"
                                        id="username"
                                        v-model="form.username"
                                        :class="{
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': hasError('username')
                                        }" placeholder="janesmith" />
                                    <ExclamationCircleIcon v-if="hasError('username')" class="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4" aria-hidden="true" />
                                </div>
                                <p class="mt-2 text-sm text-red-600" id="name-error" v-if="hasError('username')">{{ getError('username') }}</p>
                                <p class="mt-1 text-sm/6 text-gray-400">
                                    <span v-if="form.username">{{ $t('settings.your_address') }} <span class="font-medium text-gray-600">{{ form.username }}.gallera.io</span></span>
                                    <span v-else></span>
                                </p>
                                <p class="mt-1 text-sm/6 text-gray-400">{{ $t('settings.address_tip') }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-50 px-4 py-3 text-right sm:px-6">
                        <button type="submit" class="inline-flex justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus:outline-hidden cursor-pointer">{{ $t('settings.save') }}</button>
                    </div>
                </div>
            </form>

            <form @submit.prevent="submit">
                <div class="shadow-sm sm:overflow-hidden sm:rounded-md">
                    <div class="space-y-6 bg-white px-4 py-6 sm:p-6">
                        <div>
                            <h3 class="text-base font-semibold text-gray-900">{{ $t('settings.contacts') }}</h3>
                            <p class="mt-1 text-sm text-gray-500">{{ $t('settings.contacts_tip') }}</p>
                        </div>

                        <div class="grid grid-cols-6 gap-6">
                            <div class="col-span-6 sm:col-span-6">
                                <label for="instagram_url" class="block text-sm/6 font-medium text-gray-900">Instagram</label>
                                <div class="mt-2 grid grid-cols-1">
                                    <input
                                        id="instagram_url"
                                        name="instagram_url"
                                        v-model="form.instagram_url"
                                        type="text"
                                        autocomplete="instagram_url"
                                        :class="{
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': hasError('instagram_url')
                                        }" />
                                    <ExclamationCircleIcon v-if="hasError('instagram_url')" class="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4" aria-hidden="true" />
                                </div>
                                <p class="mt-2 text-sm text-red-600" id="instagram_url-error" v-if="hasError('instagram_url')">{{ getError('instagram_url') }}</p>
                            </div>

                            <div class="col-span-6 sm:col-span-6">
                                <label for="facebook_url" class="block text-sm/6 font-medium text-gray-900">Facebook</label>
                                <div class="mt-2 grid grid-cols-1">
                                    <input
                                        id="facebook_url"
                                        name="facebook_url"
                                        v-model="form.facebook_url"
                                        type="text"
                                        autocomplete="facebook_url"
                                        :class="{
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': hasError('facebook_url')
                                        }" />
                                    <ExclamationCircleIcon v-if="hasError('facebook_url')" class="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4" aria-hidden="true" />
                                </div>
                                <p class="mt-2 text-sm text-red-600" id="facebook_url-error" v-if="hasError('facebook_url')">{{ getError('facebook_url') }}</p>
                            </div>

                            <div class="col-span-6 sm:col-span-6">
                                <label for="telegram_url" class="block text-sm/6 font-medium text-gray-900">Telegram</label>
                                <div class="mt-2 grid grid-cols-1">
                                    <input
                                        id="telegram_url"
                                        name="telegram_url"
                                        v-model="form.telegram_url"
                                        type="text"
                                        autocomplete="telegram_url"
                                        :class="{
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': hasError('telegram_url')
                                        }" />
                                    <ExclamationCircleIcon v-if="hasError('telegram_url')" class="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4" aria-hidden="true" />
                                </div>
                                <p class="mt-2 text-sm text-red-600" id="telegram_url-error" v-if="hasError('telegram_url')">{{ getError('telegram_url') }}</p>
                            </div>

                            <div class="col-span-6 sm:col-span-6">
                                <label for="website_url" class="block text-sm/6 font-medium text-gray-900">{{ $t('settings.website') }}</label>
                                <div class="mt-2 grid grid-cols-1">
                                    <input
                                        id="website_url"
                                        name="website_url"
                                        v-model="form.website_url"
                                        type="text"
                                        autocomplete="website_url"
                                        :placeholder="user ? `https://${user.username}.gallera.io` : 'https://username.gallera.io'"
                                        :class="{
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': hasError('website_url')
                                        }" />
                                    <ExclamationCircleIcon v-if="hasError('website_url')" class="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4" aria-hidden="true" />
                                </div>
                                <p class="mt-2 text-sm text-red-600" id="website_url-error" v-if="hasError('website_url')">{{ getError('website_url') }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-50 px-4 py-3 text-right sm:px-6">
                        <button type="submit" class="inline-flex justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus:outline-hidden cursor-pointer">{{ $t('settings.save') }}</button>
                    </div>
                </div>
            </form>

            <form @submit.prevent="submitSecurity">
                <div class="shadow-sm sm:overflow-hidden sm:rounded-md">
                    <div class="space-y-6 bg-white px-4 py-6 sm:p-6">
                        <div>
                            <h3 class="text-base font-semibold text-gray-900">{{ $t('settings.security') }}</h3>
                            <p class="mt-1 text-sm text-gray-500">{{ $t('settings.security_tip') }}</p>
                        </div>

                        <div class="col-span-6 sm:col-span-6">
                            <label for="email" class="block text-sm/6 font-medium text-gray-900">{{ $t('settings.email') }}</label>
                            <div class="mt-2 grid grid-cols-1">
                                <input
                                    id="email"
                                    name="email"
                                    v-model="form.email"
                                    type="email"
                                    disabled
                                    autocomplete="email"
                                    :class="{
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:outline-gray-200': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': hasError('email')
                                        }" />
                                <ExclamationCircleIcon v-if="hasError('email')" class="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4" aria-hidden="true" />
                            </div>
                            <p class="mt-2 text-sm text-red-600" id="email-error" v-if="hasError('email')">{{ getError('email') }}</p>
                        </div>

                        <div class="col-span-6 sm:col-span-6 pt-3">
                            <label for="current_password" class="block text-sm/6 font-medium text-gray-900">{{ $t('settings.current_password') }}</label>
                            <div class="mt-2 grid grid-cols-1">
                                <input
                                    id="current_password"
                                    name="current_password"
                                    v-model="securityForm.current_password"
                                    type="password"
                                    :class="{
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': hasError('current_password')
                                        }" />
                                <ExclamationCircleIcon v-if="hasError('current_password')" class="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4" aria-hidden="true" />
                            </div>
                            <p class="mt-2 text-sm text-red-600" id="current_password-error" v-if="hasError('current_password')">{{ getError('current_password') }}</p>
                        </div>

                        <div class="col-span-6 sm:col-span-6">
                            <label for="password" class="block text-sm/6 font-medium text-gray-900">{{ $t('settings.current_password') }}</label>
                            <div class="mt-2 grid grid-cols-1">
                                <input
                                    id="password"
                                    name="password"
                                    v-model="securityForm.password"
                                    type="password"
                                    :class="{
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': hasError('password')
                                        }" />
                                <ExclamationCircleIcon v-if="hasError('password')" class="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4" aria-hidden="true" />
                            </div>
                            <p class="mt-2 text-sm text-red-600" id="password-error" v-if="hasError('password')">{{ getError('password') }}</p>
                        </div>

                        <div class="col-span-6 sm:col-span-6">
                            <label for="password_confirmation" class="block text-sm/6 font-medium text-gray-900">{{ $t('settings.new_password_confirmation') }}</label>
                            <div class="mt-2 grid grid-cols-1">
                                <input
                                    id="password_confirmation"
                                    name="password_confirmation"
                                    v-model="securityForm.password_confirmation"
                                    type="password"
                                    :class="{
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': hasError('password_confirmation')
                                        }" />
                                <ExclamationCircleIcon v-if="hasError('password_confirmation')" class="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4" aria-hidden="true" />
                            </div>
                            <p class="mt-2 text-sm text-red-600" id="password_confirmation-error" v-if="hasError('password_confirmation')">{{ getError('password_confirmation') }}</p>
                        </div>
                    </div>
                    <div class="bg-gray-50 px-4 py-3 text-right sm:px-6">
                        <button type="submit" class="inline-flex justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus:outline-hidden cursor-pointer">{{ $t('settings.save') }}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {mapActions, mapGetters} from "vuex";

import ControlsMenuComponent from "@/components/Users/ControlsMenuComponent.vue";
import AvatarComponent from "@/components/Users/AvatarComponent.vue";

import {User} from "@/types/UserType";
import {validationMethods} from "@/_helpers/validation";

import {updateSecurity, updateSettings} from "@/data/requests/user";
import {ResponseError} from "@/types";

import {ExclamationCircleIcon} from "@heroicons/vue/16/solid";

export default defineComponent({
    name: "UserSettingsPage",

    components: {
        AvatarComponent,
        ControlsMenuComponent,

        ExclamationCircleIcon
    },

    data() {
        return {
            isLoadingUser: false,
            isUserUpdated: false,

            form: {} as User,

            securityForm: {
                current_password: null,
                password: null,
                password_confirmation: null
            },

            errors: {} as { [key: string]: string[] },
        }
    },

    watch: {
        'form.name': function () {
            this.hideUserUpdatedMessage();

            delete this.errors['name'];
        },
        'form.avatar': function () {
            this.hideUserUpdatedMessage();

            delete this.errors['avatar'];
        },
        'form.username': function () {
            this.hideUserUpdatedMessage();

            delete this.errors['username'];
        },
        'form.instagram_url': function () {
            this.hideUserUpdatedMessage();

            delete this.errors['instagram_url'];
        },
        'form.facebook_url': function () {
            this.hideUserUpdatedMessage();

            delete this.errors['facebook_url'];
        },
        'form.telegram_url': function () {
            this.hideUserUpdatedMessage();

            delete this.errors['telegram_url'];
        },
        'form.website_url': function () {
            this.hideUserUpdatedMessage();

            delete this.errors['website_url'];
        },

        'securityForm.current_password': function () {
            this.hideUserUpdatedMessage();

            delete this.errors['current_password'];
        },
        'securityForm.password': function () {
            this.hideUserUpdatedMessage();

            delete this.errors['password'];
        },
        'securityForm.password_confirmation': function () {
            this.hideUserUpdatedMessage();

            delete this.errors['password_confirmation'];
        },
    },

    mounted() {
        this.loadUser();
    },

    computed: {
        ...mapGetters({
            user: "user/user",
            userToken: "user/token",
        }),
    },

    methods: {
        ...mapActions({
            fetchUser: "user/fetchUser",

            successAlert: "alerts/success",
            errorAlert: "alerts/error",
        }),

        ...validationMethods(),

        loadUser() {
            if(!this.form.name) {
                this.isLoadingUser = true;
            }

            this.fetchUser({token: this.userToken})
                .then((user) => {
                    console.log('fetch user');
                    this.form = { ...user };

                    this.isLoadingUser = false;
                })
                .catch(() => {
                    this.errorAlert({
                        message: this.$t('settings.fetch_error'),
                    });

                    this.isLoadingUser = false;
                });
        },

        hideUserUpdatedMessage() {
            this.isUserUpdated = false;
        },

        submit() {
            updateSettings(this.form, ({status}) => {
                if(status === "success") {
                    this.successAlert({
                        message: this.$t('settings.save_success'),
                    });
                }

                this.loadUser();
            }, (type, data) => {
                if(type == ResponseError.Validation) {
                    this.errors = data.data;

                    this.errorAlert({
                        message: this.$t('settings.validation_error'),
                    });
                } else {
                    this.errorAlert({
                        message: data.message,
                    });
                }
            })
        },

        submitSecurity() {
            updateSecurity(this.securityForm, ({status}) => {
                if(status === "success") {
                    this.securityForm = {
                        current_password: null,
                        password: null,
                        password_confirmation: null
                    };

                    setTimeout(() => {
                        this.isUserUpdated = true;
                    }, 500);
                }
            }, (type, data) => {
                if(type == ResponseError.Validation) {
                    this.errors = data.data;

                    this.errorAlert({
                        message: this.$t('settings.validation_error'),
                    });
                } else {
                    this.errorAlert({
                        message: data.message,
                    });
                }
            })
        }
    }
})
</script>